export default __webpack_public_path__ + "fb384e415be49b02184e0b3494aef67c.png";